<template>
    <!-- Begin Mailchimp Signup Form -->
    <div id="mc_embed_signup">
        <form 
            action="https://dspolitical.us3.list-manage.com/subscribe/post?u=ad28aebe25fbc5603f5370159&amp;id=a6a2ee91f7" 
            method="post" 
            id="mc-embedded-subscribe-form" 
            name="mc-embedded-subscribe-form"
            class="validate" 
            target="_blank" 
            novalidate>
            <div id="mc_embed_signup_scroll">
                <v-row align="center" class="px-3">
                    <v-text-field
                        background-color="white"
                        dense
                        type="email" 
                        value="" 
                        name="EMAIL" 
                        class="email" 
                        flat
                        id="mce-EMAIL"
                        hide-details
                        required
                        solo>
                    </v-text-field>
                    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                    <div style="position: absolute; left: -5000px;" aria-hidden="true">
                        <input class="mailchimp-embed__input" type="text" name="b_ad28aebe25fbc5603f5370159_a6a2ee91f7" tabindex="-1" value="">
                    </div>
                    <v-btn 
                        class="ml-2"
                        color="secondary"
                        type="submit" 
                        name="subscribe" 
                        id="mc-embedded-subscribe"
                        icon
                        small>
                        <v-icon small>mail</v-icon>
                    </v-btn>
                </v-row>
            </div>
        </form>
    </div>
<!--End mc_embed_signup-->
</template>
<script>
export default {
    name: 'mailchip-embed'
}
</script>
<style lang="scss">
</style>